"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var controlCharLookup = '0123456789ABCDEFHJKLMNPRSTUVWXY';
function from(bday, nnn) {
    var idx = parseInt("" + bday + nnn, 10) % controlCharLookup.length;
    return controlCharLookup.charAt(idx);
}
exports.from = from;
//# sourceMappingURL=cc.js.map